import { get, put } from '../service';
import { UrlBuilder } from '../urlBuilder';

export const getList = async (listId) => {
  const builder = new UrlBuilder(`/documents/get-list`);
  builder.add('listId', listId);

  try {
    const response = await get(builder.toString());

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
};

export const updateList = async (payload) => {
  const builder = new UrlBuilder(`/documents/update-list`);

  try {
    const response = await put(builder.toString(), payload);

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
};

export const getStatusOfProcessing = async (listId) => {
  const builder = new UrlBuilder(`/documents/get-status/${listId}`);

  try {
    const response = await get(builder.toString());

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
};

export const extractData = async (listId) => {
  const builder = new UrlBuilder(`/documents/extract/${listId}`);

  try {
    const response = await get(builder.toString());
    return response.data;
  } catch (error) {
    const serverData = error?.response?.data;
    const message =
      serverData?.message ??
      serverData?.detail ??
      serverData?.error ??
      error?.message ??
      'Extraction failed.';

    throw new Error(message);
  }
};

export const getExtractedData = async (listId) => {
  const builder = new UrlBuilder(`/documents/get-extracted-data/${listId}`);

  try {
    const response = await get(builder.toString());

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    const status = error?.response?.status;
    const detail = error?.response?.data?.detail || error?.response?.data?.message;

    if (status === 404) {
      // "No Data Found!" — treat as an empty state, not a hard failure
      const err = new Error(detail || 'No data found');
      err.status = 404;
      throw err;
    }

    const err = new Error(detail || error?.message || 'Failed to get extracted data');
    err.status = status;
    throw err;
  }
};

export const analyseData = async (listId) => {
  const builder = new UrlBuilder(`/documents/analyse/${listId}`);

  try {
    const response = await get(builder.toString());

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    const serverData = error?.response?.data;
    const message =
      serverData?.message ??
      serverData?.detail ??
      serverData?.error ??
      error?.message ??
      'Extraction failed.';

    throw new Error(message);
  }
};

export const getAnalysisData = async (listId) => {
  const builder = new UrlBuilder(`/documents/get-analysis-data/${listId}`);

  try {
    const response = await get(builder.toString());

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    const message =
      error?.response?.data?.message || error?.message || 'Failed to get analysis data';

    throw new Error(message);
  }
};
